export default {
  DOWNLOAD: '下载',
  OPEN_APP: '打开App',
  CLICK_TOP_RIGHT_CORNER: '点击右上角',
  SELECT_OPEN_IN_BROWSER: '选择在浏览器打开'
};
